import { QueryClient } from '@tanstack/react-query';
import { Api } from '../Api';
import { bindApi } from './binding';
import { createQueryClient } from './queryClient';

export type ApiClient = Api<string>;

export interface ApiRuntime {
    readonly api: ApiClient;
    readonly queryClient: QueryClient;
    /** The backend origin: REST lives under /api, the SignalR hubs at the root. */
    readonly origin: string;
}

export interface ApiRuntimeOptions {
    origin: string;
    token: string | null;
}

const securityWorker = (token: string | null) => (token ? { headers: { Authorization: `Bearer ${token}` } } : {});

/**
 * An Api and a QueryClient that belong together: one pair per request on the server, one for the
 * app in the browser. The Api is bound to the QueryClient, so every query and mutation that client
 * runs calls the backend with this runtime's credentials and nobody else's.
 */
export function createApiRuntime({ origin, token }: ApiRuntimeOptions): ApiRuntime {
    const api = new Api<string>({ baseUrl: `${origin}/api`, securityWorker });
    api.setSecurityData(token);
    const queryClient = createQueryClient();
    bindApi(queryClient, api);
    return { api, queryClient, origin };
}
